import PurchaseRouter from 'scripts/purchase/PurchaseRouter.svelte'
import { APP_NAME, VIEW_NAME } from "scripts/router";
let app = undefined
if (APP_NAME === 'purchases') {
    app = new PurchaseRouter({
        target: document.querySelector('.sv-component')!,
    });
}

export default app;